import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';
import { useSelector } from 'react-redux';

import CommonMenu from '../../../components/common-menu/CommonMenu';
import { USER_ROLES } from '../../../constants';

const SonarMenu = () => {
  const { t } = useTranslation('projects');
  const navigate = useNavigate();
  const { id } = useParams();

  const userStatus = useSelector((state) => state.securityNew.userStatus);

  const handleCollectData = () => {
    navigate(`/project/sonar/collect-data/${id}`);
  };

  const handleEditProject = () => {
    navigate(`/projects/edit/sonar/${id}`);
  };

  const handleOpenProject = () => {
    navigate(`/project/sonar/${id}`);
  };

  const editPermissions = [USER_ROLES.GLOBAL_ADMIN, USER_ROLES.COMPANY_ADMIN];
  const collectDataPermissions = [
    USER_ROLES.GLOBAL_ADMIN,
    USER_ROLES.COMPANY_ADMIN,
    USER_ROLES.GLOBAL_USER,
    USER_ROLES.ROLE_CUSTOMER,
    USER_ROLES.COMPANY_USER,
  ];

  const userMenuOptions = [
    {
      label: t('edit'),
      value: 'edit',
      disabled: !editPermissions.some((element) => userStatus.includes(element)),
      onClick: handleEditProject,
    },
    {
      label: t('collectData'),
      value: 'collectData',
      disabled: !collectDataPermissions.some((element) => userStatus.includes(element)),
      onClick: handleCollectData,
    },
  ];

  const selectMenuOption = (selectedItem) => {
    if (selectedItem.onClick) {
      selectedItem.onClick();
    }
  };

  return <CommonMenu options={userMenuOptions} onSelect={selectMenuOption} />;
};

export default SonarMenu;
